"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconLargeScaleHeatPump = function IconLargeScaleHeatPump(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m31 12.593 7 7.17V32h8.616a24 24 0 0 1-.815 2H35.006l.043 7h5.834a24 24 0 0 1-2.298 2H29v1l-.01.204a2 2 0 0 1-1.786 1.785L27 46h-6l-.204-.01A2 2 0 0 1 19 44v-1h-4.001A2 2 0 0 1 13 41v-2H5.388a24 24 0 0 1-1.452-2H13v-3H2.278a24 24 0 0 1-.816-2H22V21H12v7h-2v-9h6V3h15zM21 44h6v-4h-6zm-6.001-3H19v-1a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1h4.049l-.043-6.987V34H15zM24 20.576V32h12V20.577l-6.001-6.145zM34 29h-5v-7h5zm-4-1h3v-5h-3zm-10-1h-4v-4h4zm-3-1h2v-2h-2zm1-7h4.745L29 12.593V4.999H18zm4-6h-1v-2h1zm4 0h-1v-2h1zm-4-4h-1V7h1zm4 0h-1V7h1z"
  })));
};

export { IconLargeScaleHeatPump, IconLargeScaleHeatPump as default };
